import React, { useEffect } from "react";
import IslandHeader from "components/IslandHeader";
import UserBioContainer from "./UserBioContainer";
import UserGroupContainer from "./UserGroupContainer";
import UserRoleContainer from "./UserRoleContainer";

export function TeamProfileComponent({getUserProfileDispatch, userPrivilege, locationId, match}) {

  useEffect(() => {
    const userPrivilegeId = match.params.id; //this is user privilege id
    getUserProfileDispatch(locationId, userPrivilegeId);

  }, [])

  return (
    <div className="island-container">
      <div className="island-content">
          <IslandHeader title="Employee Profile" />
          <UserBioContainer userPrivilege={userPrivilege} />
          <UserRoleContainer userPrivilege={userPrivilege} locationId={locationId} />
          <UserGroupContainer userPrivilege={userPrivilege} locationId={locationId} />
      </div>
    </div>
  );
}

export default TeamProfileComponent;